import { Link } from 'react-router-dom';
import { Bell, Settings, LogOut } from 'lucide-react';
import { ThemeToggle } from '@/components/theme/ThemeToggle';
import { useAuth } from '@/lib/store';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/components/theme/ThemeProvider';
import logoLight from '@/img/Logo.svg';
import logoDark from '@/img/LogoDark.svg';
import { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';

const notifications = [
    {
    date: '23/02',
    message: 'Added Malware Intelligence & Sandbox Analysis',
  },
  {
    date: '17/02',
    message: 'Added new Product - Ransomware Intelligence',
  },
  {
    date: '23/01',
    message: 'Added Integrations',
  },
  {
    date: '20/01',
    message: 'Search functionality drastically improved',
  },
  {
    date: '17/01',
    message: 'New Dashboard page, check it out!',
  },
];

export function Header() {
  const logout = useAuth((state) => state.logout);
  const { theme } = useTheme();
  const [hasSeenNotifications, setHasSeenNotifications] = useState(false);

  const handleNotificationsOpen = () => {
    setHasSeenNotifications(true);
  };

  return (
    <header className="sticky top-0 z-40 h-16 border-b bg-transparent">
      <div className="relative flex h-full items-center justify-end px-4">
        {/* Mobile Logo - Absolute Center */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 md:hidden">
          <img 
            src={theme === 'dark' ? logoDark : logoLight} 
            alt="Logo" 
            className="h-7 w-7"
          />
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <ThemeToggle />
          
          {/* Notifications Dropdown */}
          <DropdownMenu onOpenChange={handleNotificationsOpen}>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="rounded-full hover:bg-accent relative"
              >
                <Bell className="h-5 w-5 text-muted-foreground" />
                {!hasSeenNotifications && (
                  <span className="absolute top-0.5 right-0.5 h-2 w-2 rounded-full bg-blue-500" />
                )}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-80">
              <DropdownMenuLabel>Notifications</DropdownMenuLabel>
              <DropdownMenuSeparator />
              {notifications.map((notification, index) => (
                <DropdownMenuItem key={index} className="flex flex-col items-start py-3">
                  <div className="text-sm font-medium">{notification.message}</div>
                  <div className="text-xs text-muted-foreground">{notification.date}</div>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          {/* User Menu Dropdown */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="rounded-full hover:bg-accent opacity-100"
              >
                <Settings className="h-5 w-5 text-muted-foreground" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem asChild>
                <Link to="/settings">
                <Settings className="mr-2 h-4 w-4" />
                Settings
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => logout()}>
                <LogOut className="mr-2 h-4 w-4" />
                Log out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}